export class ForgeProjectMembership {
    constructor(model) {
        this.user = model.user;
        this.role = model.role;
        this.userId = model.user.id;
        this.effectiveRole = model.effectiveRole;
        this.forgeProjectId = model.forgeProjectId;
        this.workspaceMembershipId = model.workspaceMembershipId;
        this.workspaceRole = model.workspaceRole;
        this.isDeactivated = model.isDeactivated;
    }
    toRemote() {
        return Object.assign({}, this);
    }
}
